<template>
  <v-form>
    <v-row>
      <v-col cols="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <GradeClassStudentSelect
              @changed="gradeClassStudentChange"
              :classCol="{ cols: 12, sm: 12, md: 12 }"
              disableGradeSelect
              disableStudentSelect
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-autocomplete
              outlined
              :items="[
                { title: 'Tất cả', value: null },
                { title: 'Có học bù', value: true },
                { title: 'Không học bù', value: false },
              ]"
              item-text="title"
              item-value="value"
              v-model="isMakeup"
              hide-details
              dense
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex align-end" cols="12" sm="12" md="2">
        <v-btn class="search-button" :class="{ 'px-2': windowWidth < 1100 }" @click="onFilterChanged" outlined>
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapActions } from 'vuex'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import get from 'lodash-es/get'

export default {
  components: { GradeClassStudentSelect },
  data: () => ({ windowWidth: window.innerWidth, classId: null, isMakeup: null }),
  methods: {
    ...mapActions({ search: 'scheduleVacation/search' }),
    async onFilterChanged() {
      this.$loading.active = true
      await this.search({ class: this.classId, isMakeup: this.isMakeup })
      this.$loading.active = false
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    gradeClassStudentChange(data) {
      this.classId = get(data, 'class.id')
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  },
}
</script>
